// 请将 your-store.myshopify.com 替换为你的真实店铺域名
const shopifyDomain = 'www.stonylab.com';
// 这里填写你在App Proxy中设置的完整路径
const proxyPath = '/apps/my-postage-time-api';
const token = 'MOkDVkjAXb6A1P4N8Ijc0PK8KbdXVqPA'
// const token2 = 'b3352325bc45a0c1f644003b948e17e8'
// 构建请求参数（GET请求）
// const params = new URLSearchParams({
//     skus:"NY-ZXP-ZG-1PK-100ml",
//     countrycodes:"1",
//     token:'MOkDVkjAXb6A1P4N8Ijc0PK8KbdXVqPA'
// });
function getInventoryNum2(params) {
    // 完整的请求URL
    // const url = `${shopifyDomain}${proxyPath}?${params.toString()}`;
    const url = `https://erp.myjnd.top/api/g?${params.toString()}`

    // 使用 Fetch API 发送 GET 请求
    fetch(url, {
        method: 'GET',
        headers: {
            // App Proxy 会自动处理Shopify的认证，前端不需要再传递任何令牌
            'Content-Type': 'application/json',
        }
    })
    .then(response => {
        // 首先检查网络响应状态
        if (!response.ok) {
            // 如果接口返回错误，尝试解析错误信息
            return response.text().then(text => {
                throw new Error(`HTTP error! status: ${response.status}, message: ${text}`);
            });
        }
        // 假设你的接口返回的是 JSON 格式
        return response.json();
    })
    .then(data => {
        // 请求成功，在这里处理你的数据
        return data
        // 在这里编写你的业务逻辑，例如更新页面DOM
    })
    .catch(error => {
        // 统一处理网络错误或上面抛出的错误
        console.error('请求失败：', error.message);
    });
}
function getInventoryNum(params) {
    const url = `https://erp.myjnd.top/api/g?${params.toString()}`;

    // 返回 fetch 的 Promise 链
    return fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then(response => {
        // 检查响应状态
        if (!response.ok) {
            // 如果出错，读取错误信息并抛出
            return response.text().then(text => {
                throw new Error(`HTTP error! status: ${response.status}, message: ${text}`);
            });
        }
        // 解析 JSON 数据
        return response.json();
    });
    // 注意：不再在这里处理 catch，让调用者自行处理错误
}